module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dy-item-wrap', {
    attrs: {
      "item": _vm.item
    }
  }, [_c('el-slider', _vm._g(_vm._b({
    attrs: {
      "range": _vm.item.isRange
    }
  }, 'el-slider', _vm.$attrs, false), _vm.$listeners))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50830373"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DynamicForm/widgets/SliderWidget.vue
// module id = 719
// module chunks = 20